import Filter from './Filter'

export default class MonitoringReport extends Filter {
    filterComponent = import('@/views/components/filters/compoents/MonitoringReportFilterComponent.vue')

    static ORGANIZATION = 'apply_doc__organization'

    static COURSE = 'course'

    static DC_TYPE = 'dc_type'

    static PERIOD = 'period_id'

    static REPORT_PERIOD = 'report_period_id'

    static QUARTER = 'quarter_id'

    static REPORT_QUARTER = 'report_quarter_id'

    static STATUS = 'status'

    type = ''

    fields = {
      [MonitoringReport.ORGANIZATION]: {
        label: 'Organization',
      },
      [MonitoringReport.COURSE]: {
        label: 'Course',
      },
      [MonitoringReport.DC_TYPE]: {
        label: 'Dc Type',
      },
      [MonitoringReport.PERIOD]: {
        label: 'Admission year',
      },
      [MonitoringReport.QUARTER]: {
        label: 'Admission quarter',
      },
      [MonitoringReport.REPORT_PERIOD]: {
        label: 'Reporting year',
      },
      [MonitoringReport.REPORT_QUARTER]: {
        label: 'Reporting quarter',
      },
      [MonitoringReport.STATUS]: {
        label: 'Status',
      },
    }

    constructor(type) {
      super()
      this.type = type
    }
}
